module.exports = __webpack_public_path__ + "img/ring_y_o_null_null@2x.0bc40f47.png";